import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
    makeResetWalletLimitRequest,
    makeUpdateWalletLimitRequest,
    updateWalletSwitchOffLimitPopupValue,
    updateWalletSwitchOffLimitPopupVisibility,
    WalletSwitchOffLimitPopupAction
} from '../../actions/walletSwitchOffLimitEditPopup';
import {
    WalletSwitchOffLimitEditPopup,
    WalletSwitchOffLimitEditPopupProps
} from '../../components/WalletSwitchOffLimitEditPopup/WalletSwitchOffLimitEditPopup';
import { WalletSwitchOffLimitEditPopupValue, WalletSwitchOffLimitPopupState } from '../../typings/walletState';

export type StateProps = Pick<
    WalletSwitchOffLimitEditPopupProps,
    | 'value'
    | 'payerData'
    | 'paymentMethods'
    | 'isSaving'
    | 'isVisible'
    | 'minSum'
    | 'maxSum'
    | 'currency'
    | 'canResetLimit'
    | 'isResetting'
    | 'isNdsActive'
    | 'validation'
>;

export type DispatchProps = Pick<
    WalletSwitchOffLimitEditPopupProps,
    'onValueChange' | 'onResetButtonClick' | 'onSaveButtonClick' | 'onClose'
>;

export const mapStateToProps = (state: WalletSwitchOffLimitPopupState): StateProps => {
    const {
        isSaving,
        isResetting,
        isVisible,
        value,
        paymentData,
        minSum,
        maxSum,
        currency,
        canResetLimit,
        isNdsActive,
        validationResult
    } = state;

    return {
        value,
        payerData: paymentData && paymentData.payerData,
        paymentMethods:
            paymentData && paymentData.paymentMethods && value.payerId
                ? paymentData.paymentMethods[value.payerId]
                : undefined,
        isSaving,
        isVisible,
        isNdsActive,
        isResetting,
        minSum,
        maxSum,
        currency,
        canResetLimit,
        validation: validationResult
    };
};

const mapDispatchToProps = (dispatch: Dispatch<WalletSwitchOffLimitPopupAction>): DispatchProps => {
    return {
        onValueChange: (value: WalletSwitchOffLimitEditPopupValue) => {
            dispatch(updateWalletSwitchOffLimitPopupValue(value));
        },
        onResetButtonClick: () => {
            dispatch(makeResetWalletLimitRequest());
        },
        onSaveButtonClick: () => {
            dispatch(makeUpdateWalletLimitRequest());
        },
        onClose: () => {
            dispatch(updateWalletSwitchOffLimitPopupVisibility(false));
        }
    };
};

export const WalletSwitchOffLimitEditPopupContainer = connect<StateProps, DispatchProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(WalletSwitchOffLimitEditPopup);
